// Same single-file, named-export pattern as monitors/index.js and sheets/index.js.
// Keep keys in identical order across languages so drift is easy to spot.

export const enrich_en = {
  // /enrich tabs
  enrich_tab_new: "New enrichment",
  enrich_tab_history: "History",
  enrich_no_profile: "No active profile selected",

  // /enrich body header
  enrich_wizard_title: "Enrich a CSV",
  enrich_wizard_subtitle: "Upload your file. We match each row against Pubrio's database. You're charged only for matched rows.",
  ComingSoon: "Coming soon",

  // /enrich wizard step labels
  enrich_step_upload: "Upload",
  enrich_step_map: "Map columns",
  enrich_step_run: "Run",

  // /enrich step 1 - kind picker
  enrich_kind_title: "What are you enriching?",
  enrich_kind_desc: "Pick the type of records in your file.",
  enrich_kind_people_title: "People",
  enrich_kind_people_desc: "Match contacts to find verified emails, phones, LinkedIn profiles, and job titles.",
  enrich_kind_people_eg: "E.g. a CSV of leads with first name, last name, and company.",
  enrich_kind_company_title: "Companies",
  enrich_kind_company_desc: "Match companies to find domain, industry, size, and HQ location.",
  enrich_kind_company_eg: "E.g. a CSV of company names or domains.",

  // /enrich step 1 - upload
  enrich_upload_title: "Upload your file",
  enrich_upload_desc: "Drag and drop a file, or browse. We support .csv, .xlsx, .xls, and .txt.",
  enrich_upload_hint: "Up to {rows} rows per file",
  enrich_upload_done_meta: "{rows} rows · {cols} columns detected",
  enrich_upload_replace: "Replace",
  enrich_notify_by_email: "Email me when the enrichment is ready",

  // /enrich step 2 - map
  enrich_map_title: "Map your columns",
  enrich_map_subtitle: "Detected {count} rows. Match each CSV column to an enrichment field.",
  enrich_map_file_column: "Your CSV column",
  enrich_map_target_field: "Pubrio field",
  enrich_map_auto_detected: "Auto-detected",
  enrich_map_match_key_required: "Map LinkedIn URL, OR a Name (or First + Last) plus Company (name or domain) to enable enrichment.",
  enrich_disabled_no_kind: "Pick what you're enriching first.",
  enrich_disabled_no_file: "Upload a file to continue.",
  enrich_disabled_no_contact_types: "Pick at least one contact type to enrich.",
  // Strategy status — shown once a viable match strategy is reachable.
  enrich_map_strategy_linkedin: "We'll match each row by LinkedIn URL.",
  enrich_map_strategy_email: "We'll match each row by work email.",
  enrich_map_strategy_name_company: "We'll match each row by name and company.",
  enrich_map_strategy_mixed: "Each row uses the best available match: LinkedIn URL, email, or name + company.",
  enrich_map_strategy_company: "We'll look up each company by domain.",
  enrich_map_hint_need_company_key: "Map company domain or name.",
  enrich_map_hint_need_company_domain: "Map a Company Domain column (or an Email column we can derive domain from).",
  enrich_match_status_matched: "Matched",
  enrich_match_status_unmatched: "Unmatched",
  enrich_match_status_no_match_key: "No match key",
  enrich_match_status_no_linkedin_url: "No LinkedIn URL",
  // Progressive hints — surface the smallest next step the user can take.
  enrich_map_hint_start: "Map LinkedIn URL, or Name + Company.",
  enrich_map_hint_need_company: "Almost there — also map a Company name or Company domain column.",
  enrich_map_hint_need_last_name: "We also need Last name and Company (name or domain).",
  enrich_map_hint_need_first_name: "We also need First name and Company (name or domain).",
  enrich_map_hint_need_name: "We also need a Name (or First + Last).",

  // /enrich step 3 - review and start
  enrich_cost_review_title: "Review and start",
  enrich_cost_contact_types_title: "Contact types to enrich",
  enrich_cost_contact_types_desc: "Pick what you want returned for each matched contact. You're charged per match, per type.",
  enrich_contact_email_desc: "Verified work email address.",
  enrich_contact_phone_desc: "Direct dial or work phone number.",
  enrich_contact_mobile_desc: "Personal mobile number where available.",
  enrich_cost_summary_title: "Enrichment summary",
  enrich_cost_filename: "File",
  enrich_cost_rows_total: "Rows in file",
  enrich_cost_rows_unique: "Unique rows after dedup",
  enrich_cost_max_credits: "If all rows match",
  enrich_cost_per_row: "Total per matched row",
  enrich_cost_if_all_match: "If all {rows} rows match",
  enrich_cost_breakdown_email: "Email",
  enrich_cost_breakdown_phone: "Phone",
  enrich_cost_breakdown_company: "Company info",
  enrich_company_enrichment_label: "Also include company info (domain, name, generic phone, industry)",
  enrich_company_enrichment_needs_domain: "Map a CSV column to Company domain to enable this.",
  enrich_cost_only_matched: "You're charged only for matched rows. Unmatched rows use no credits.",
  enrich_cost_balance: "Credit balance",
  enrich_cost_current_balance: "Current balance",
  enrich_cost_after_max: "Balance after worst-case spend",
  enrich_cost_contact_types: "Contact types to enrich",
  enrich_cost_start: "Start enrichment",
  enrich_cost_estimate_failed: "Could not estimate enrichment cost",
  enrich_cost_start_failed: "Could not start enrichment",

  // /enrich right rail (summary)
  enrich_summary_title: "Summary",
  enrich_summary_file_title: "Source file",
  enrich_summary_file_empty: "Drop a CSV in step 1 to begin",
  enrich_summary_kind: "Type",
  enrich_summary_rows: "Rows",
  enrich_summary_columns: "Columns",
  enrich_summary_sample: "Sample row",
  enrich_summary_mapping_title: "Mapping",
  enrich_summary_mapping_empty: "Pending",
  enrich_summary_mapping_count: "{n} field mapped | {n} fields mapped",
  enrich_summary_contact_types: "Contact types",
  enrich_summary_match_method: "Match method",
  enrich_summary_match_method_pending: "Map a match key to begin",
  enrich_summary_cost_title: "Estimated cost",
  enrich_summary_cost_sub: "Charged only on matched rows",
  enrich_summary_howto_title: "How matching works",
  enrich_summary_howto_1: "We match on Email, LinkedIn URL, or Name + Company.",
  enrich_summary_howto_2: "Each matched row is enriched with the contact types you pick.",
  enrich_summary_howto_3: "Unmatched rows return blank values and use no credits.",

  // /enrich step 4 - run
  enrich_run_running_title: "Enriching your file…",
  enrich_run_running_desc: "This may take a few minutes. You can leave this page — we'll keep working in the background.",
  enrich_run_submitting_title: "Starting your enrichment…",
  enrich_run_submitting_desc: "Submitting your job to the server. This usually finishes in a few seconds.",
  enrich_run_email_hint: "We'll email you when the enriched file is ready.",
  enrich_run_failed_title: "Enrichment failed",
  enrich_run_failed_desc: "Something went wrong while processing the file.",
  enrich_run_try_again: "Try again",
  enrich_run_done_title: "Enrichment complete",
  enrich_run_download_csv: "Download CSV",
  enrich_run_view_in_app: "View in app",
  enrich_run_new_job: "Start a new job",
  enrich_run_download_failed: "Could not download enriched file",

  // /enrich step 4 metrics
  enrich_metric_rows: "Rows in file",
  enrich_metric_processed: "Rows processed",
  enrich_metric_matched: "Matched",
  enrich_metric_unmatched: "Unmatched",
  enrich_metric_credits_used: "Credits used",
  enrich_run_rows_skipped: "{total} rows skipped: {empty} empty, {invalid} invalid LinkedIn URL.",

  // /enrich jobs tab
  enrich_jobs_title: "Enrichment history",
  enrich_jobs_empty: "No enrichment jobs yet. Switch to New enrichment to upload your first CSV.",
  enrich_jobs_filename: "File",
  enrich_jobs_kind: "Type",
  enrich_jobs_submitted: "Submitted",
  enrich_jobs_rows: "Rows",
  enrich_jobs_matched: "Matched",
  enrich_jobs_credits: "Credits",
  enrich_jobs_status: "Status",
  enrich_jobs_actions: "Actions",
  enrich_status_queued: "Queued",
  enrich_status_running: "Running",
  enrich_status_completed: "Completed",
  enrich_status_failed: "Failed",
  enrich_history_search_placeholder: "Search by filename",
  enrich_history_filename_unknown: "Untitled enrichment",
  "enrich_history-table-empty-title": "No enrichment jobs yet",
  "enrich_history-table-empty-desc": "Upload a CSV in New enrichment to get started.",
  enrich_run_progress_label: "Enriching",
  enrich_run_progress_complete: "Done!",

  // /enrich result viewer
  enrich_results_title: "Enriched results",
  enrich_results_showing: "Showing {rows} rows",
  enrich_results_showing_filtered: "Showing {rows} of {total} rows",
  enrich_results_search_placeholder: "Search rows",
  enrich_results_empty: "This job hasn't produced a result file yet.",
  enrich_results_no_match: "No rows match your search.",
  enrich_results_load_failed: "Could not load results",
  enrich_results_matched: "{count} matched",
  enrich_results_columns: "Columns",
};

export const enrich_zhCn = {
  enrich_tab_new: "新建增强",
  enrich_tab_history: "历史记录",
  enrich_no_profile: "未选择活动配置文件",

  enrich_wizard_title: "增强 CSV",
  enrich_wizard_subtitle: "上传您的文件。我们会将每行与 Pubrio 数据库匹配。仅匹配的行会扣费。",
  ComingSoon: "即将推出",

  enrich_step_upload: "上传",
  enrich_step_map: "映射列",
  enrich_step_run: "运行",

  enrich_kind_title: "您要增强什么？",
  enrich_kind_desc: "选择文件中的记录类型。",
  enrich_kind_people_title: "联系人",
  enrich_kind_people_desc: "匹配联系人以查找已验证的电子邮件、电话、领英资料和职位。",
  enrich_kind_people_eg: "例如，包含名、姓和公司的潜在客户 CSV。",
  enrich_kind_company_title: "公司",
  enrich_kind_company_desc: "匹配公司以查找域名、行业、规模和总部位置。",
  enrich_kind_company_eg: "例如，包含公司名称或域名的 CSV。",

  enrich_upload_title: "上传文件",
  enrich_upload_desc: "拖放文件或浏览。支持 .csv、.xlsx、.xls 和 .txt。",
  enrich_upload_hint: "每个文件最多 {rows} 行",
  enrich_upload_done_meta: "检测到 {rows} 行 · {cols} 列",
  enrich_upload_replace: "替换",
  enrich_notify_by_email: "增强完成时通过电子邮件通知我",

  enrich_map_title: "映射您的列",
  enrich_map_subtitle: "检测到 {count} 行。将每个 CSV 列匹配到一个增强字段。",
  enrich_map_file_column: "您的 CSV 列",
  enrich_map_target_field: "Pubrio 字段",
  enrich_map_auto_detected: "自动检测",
  enrich_map_match_key_required: "映射领英网址，或映射姓名（或名字 + 姓氏）+ 公司（名称或域名）以启用增强。",
  enrich_disabled_no_kind: "请先选择增强类型。",
  enrich_disabled_no_file: "请上传文件以继续。",
  enrich_disabled_no_contact_types: "请至少选择一种联系方式进行增强。",
  enrich_map_strategy_linkedin: "我们将通过领英网址匹配每一行。",
  enrich_map_strategy_email: "我们将通过工作邮箱匹配每一行。",
  enrich_map_strategy_name_company: "我们将通过姓名和公司匹配每一行。",
  enrich_map_strategy_mixed: "每一行将使用最合适的方式匹配：领英网址、邮箱或姓名 + 公司。",
  enrich_map_strategy_company: "我们将通过域名查找每一家公司。",
  enrich_map_hint_need_company_key: "请映射公司域名或公司名。",
  enrich_map_hint_need_company_domain: "请映射公司域名列(或邮箱列,我们可以从中提取域名)。",
  enrich_match_status_matched: "已匹配",
  enrich_match_status_unmatched: "未匹配",
  enrich_match_status_no_match_key: "无匹配键",
  enrich_match_status_no_linkedin_url: "无领英网址",
  enrich_map_hint_start: "请映射领英网址，或者姓名 + 公司。",
  enrich_map_hint_need_company: "就快好了 — 还需映射公司名称或公司域名列。",
  enrich_map_hint_need_last_name: "还需映射姓氏和公司（名称或域名）。",
  enrich_map_hint_need_first_name: "还需映射名字和公司（名称或域名）。",
  enrich_map_hint_need_name: "还需映射姓名（或名字 + 姓氏）。",

  enrich_cost_review_title: "审核并启动",
  enrich_cost_contact_types_title: "要增强的联系人类型",
  enrich_cost_contact_types_desc: "选择每个匹配联系人想要返回的内容。每次匹配按类型计费。",
  enrich_contact_email_desc: "已验证的工作电子邮件地址。",
  enrich_contact_phone_desc: "直拨或工作电话号码。",
  enrich_contact_mobile_desc: "可用的个人手机号码。",
  enrich_cost_summary_title: "增强摘要",
  enrich_cost_filename: "文件",
  enrich_cost_rows_total: "文件中的行数",
  enrich_cost_rows_unique: "去重后的唯一行",
  enrich_cost_max_credits: "如果所有行都匹配",
  enrich_cost_per_row: "每个匹配行的总计",
  enrich_cost_if_all_match: "如果所有 {rows} 行都匹配",
  enrich_cost_breakdown_email: "电子邮件",
  enrich_cost_breakdown_phone: "电话",
  enrich_cost_breakdown_company: "公司信息",
  enrich_company_enrichment_label: "同时包含公司信息（域名、名称、通用电话、行业）",
  enrich_company_enrichment_needs_domain: "将 CSV 列映射到公司域名以启用此功能。",
  enrich_cost_only_matched: "仅匹配的行会扣费。未匹配的行不消耗信用点。",
  enrich_cost_balance: "信用点余额",
  enrich_cost_current_balance: "当前余额",
  enrich_cost_after_max: "最坏情况支出后的余额",
  enrich_cost_contact_types: "要增强的联系人类型",
  enrich_cost_start: "开始增强",
  enrich_cost_estimate_failed: "无法估算增强成本",
  enrich_cost_start_failed: "无法开始增强",

  enrich_summary_title: "摘要",
  enrich_summary_file_title: "源文件",
  enrich_summary_file_empty: "在第 1 步放入 CSV 开始",
  enrich_summary_kind: "类型",
  enrich_summary_rows: "行数",
  enrich_summary_columns: "列数",
  enrich_summary_sample: "示例行",
  enrich_summary_mapping_title: "映射",
  enrich_summary_mapping_empty: "待定",
  enrich_summary_mapping_count: "已映射 {n} 个字段 | 已映射 {n} 个字段",
  enrich_summary_contact_types: "联系人类型",
  enrich_summary_match_method: "匹配方式",
  enrich_summary_match_method_pending: "映射匹配键以开始",
  enrich_summary_cost_title: "估算成本",
  enrich_summary_cost_sub: "仅匹配的行扣费",
  enrich_summary_howto_title: "匹配的工作原理",
  enrich_summary_howto_1: "我们通过电子邮件、领英网址或姓名 + 公司进行匹配。",
  enrich_summary_howto_2: "每个匹配的行都会按您选择的联系人类型进行增强。",
  enrich_summary_howto_3: "未匹配的行返回空值，不消耗信用点。",

  enrich_run_running_title: "正在增强您的文件…",
  enrich_run_running_desc: "可能需要几分钟。您可以离开此页面 — 我们会在后台继续处理。",
  enrich_run_submitting_title: "正在启动您的增强任务…",
  enrich_run_submitting_desc: "正在向服务器提交任务。通常几秒内完成。",
  enrich_run_email_hint: "增强文件准备就绪时，我们会通过电子邮件通知您。",
  enrich_run_failed_title: "增强失败",
  enrich_run_failed_desc: "处理文件时出错。",
  enrich_run_try_again: "重试",
  enrich_run_done_title: "增强完成",
  enrich_run_download_csv: "下载 CSV",
  enrich_run_view_in_app: "在应用中查看",
  enrich_run_new_job: "开始新任务",
  enrich_run_download_failed: "无法下载增强文件",

  enrich_metric_rows: "文件中的行数",
  enrich_metric_processed: "已处理的行",
  enrich_metric_matched: "已匹配",
  enrich_metric_unmatched: "未匹配",
  enrich_metric_credits_used: "已使用的信用点",
  enrich_run_rows_skipped: "跳过 {total} 行：{empty} 空行，{invalid} 个无效领英网址。",

  enrich_jobs_title: "增强历史",
  enrich_jobs_empty: "尚无增强任务。切换到\"新建增强\"以上传您的第一个 CSV。",
  enrich_jobs_filename: "文件",
  enrich_jobs_kind: "类型",
  enrich_jobs_submitted: "提交时间",
  enrich_jobs_rows: "行数",
  enrich_jobs_matched: "已匹配",
  enrich_jobs_credits: "信用点",
  enrich_jobs_status: "状态",
  enrich_jobs_actions: "操作",
  enrich_status_queued: "已排队",
  enrich_status_running: "运行中",
  enrich_status_completed: "已完成",
  enrich_status_failed: "失败",
  enrich_history_search_placeholder: "按文件名搜索",
  enrich_history_filename_unknown: "未命名增强",
  "enrich_history-table-empty-title": "尚无增强任务",
  "enrich_history-table-empty-desc": "在\"新建增强\"中上传 CSV 以开始。",
  enrich_run_progress_label: "正在增强",
  enrich_run_progress_complete: "完成！",

  enrich_results_title: "增强结果",
  enrich_results_showing: "显示 {rows} 行",
  enrich_results_showing_filtered: "显示 {rows} / {total} 行",
  enrich_results_search_placeholder: "搜索行",
  enrich_results_empty: "此任务尚未生成结果文件。",
  enrich_results_no_match: "没有行匹配您的搜索。",
  enrich_results_load_failed: "无法加载结果",
  enrich_results_matched: "已匹配 {count}",
  enrich_results_columns: "列",
};

export const enrich_zhHk = {
  enrich_tab_new: "新增增強",
  enrich_tab_history: "歷史記錄",
  enrich_no_profile: "未選擇活動配置文件",

  enrich_wizard_title: "增強 CSV",
  enrich_wizard_subtitle: "上傳您的檔案。我們會將每行與 Pubrio 資料庫比對。僅符合的行會扣費。",
  ComingSoon: "即將推出",

  enrich_step_upload: "上傳",
  enrich_step_map: "對應欄位",
  enrich_step_run: "執行",

  enrich_kind_title: "您要增強什麼？",
  enrich_kind_desc: "選擇檔案中的記錄類型。",
  enrich_kind_people_title: "聯絡人",
  enrich_kind_people_desc: "比對聯絡人以查找已驗證的電子郵件、電話、領英資料和職稱。",
  enrich_kind_people_eg: "例如，包含名、姓和公司的潛在客戶 CSV。",
  enrich_kind_company_title: "公司",
  enrich_kind_company_desc: "比對公司以查找網域、產業、規模和總部位置。",
  enrich_kind_company_eg: "例如，包含公司名稱或網域的 CSV。",

  enrich_upload_title: "上傳檔案",
  enrich_upload_desc: "拖放檔案或瀏覽。支援 .csv、.xlsx、.xls 和 .txt。",
  enrich_upload_hint: "每個檔案最多 {rows} 行",
  enrich_upload_done_meta: "偵測到 {rows} 行 · {cols} 欄",
  enrich_upload_replace: "取代",
  enrich_notify_by_email: "增強完成時透過電子郵件通知我",

  enrich_map_title: "對應您的欄位",
  enrich_map_subtitle: "偵測到 {count} 行。將每個 CSV 欄位對應到一個增強欄位。",
  enrich_map_file_column: "您的 CSV 欄位",
  enrich_map_target_field: "Pubrio 欄位",
  enrich_map_auto_detected: "自動偵測",
  enrich_map_match_key_required: "對應領英網址，或對應姓名（或名字 + 姓氏）+ 公司（名稱或網域）以啟用增強。",
  enrich_disabled_no_kind: "請先選擇增強類型。",
  enrich_disabled_no_file: "請上傳檔案以繼續。",
  enrich_disabled_no_contact_types: "請至少選擇一種聯絡方式進行增強。",
  enrich_map_strategy_linkedin: "我們將透過領英網址比對每一行。",
  enrich_map_strategy_email: "我們將透過工作電郵比對每一行。",
  enrich_map_strategy_name_company: "我們將透過姓名和公司比對每一行。",
  enrich_map_strategy_mixed: "每一行將以最合適的方式比對：領英網址、電郵或姓名 + 公司。",
  enrich_map_strategy_company: "我們將透過網域查找每一家公司。",
  enrich_map_hint_need_company_key: "請映射公司網域或公司名。",
  enrich_map_hint_need_company_domain: "請映射公司網域欄位(或電子郵件欄位,我們可以從中擷取網域)。",
  enrich_match_status_matched: "已比對",
  enrich_match_status_unmatched: "未比對",
  enrich_match_status_no_match_key: "無比對鍵",
  enrich_match_status_no_linkedin_url: "無領英網址",
  enrich_map_hint_start: "請對應領英網址，或者姓名 + 公司。",
  enrich_map_hint_need_company: "快完成了 — 還需對應公司名稱或公司網域欄位。",
  enrich_map_hint_need_last_name: "還需對應姓氏和公司（名稱或網域）。",
  enrich_map_hint_need_first_name: "還需對應名字和公司（名稱或網域）。",
  enrich_map_hint_need_name: "還需對應姓名（或名字 + 姓氏）。",

  enrich_cost_review_title: "審核並啟動",
  enrich_cost_contact_types_title: "要增強的聯絡人類型",
  enrich_cost_contact_types_desc: "選擇每個符合聯絡人想要回傳的內容。每次比對按類型計費。",
  enrich_contact_email_desc: "已驗證的工作電子郵件地址。",
  enrich_contact_phone_desc: "直撥或工作電話號碼。",
  enrich_contact_mobile_desc: "可用的個人手機號碼。",
  enrich_cost_summary_title: "增強摘要",
  enrich_cost_filename: "檔案",
  enrich_cost_rows_total: "檔案中的行數",
  enrich_cost_rows_unique: "去重後的唯一行",
  enrich_cost_max_credits: "如果所有行都符合",
  enrich_cost_per_row: "每個符合行的總計",
  enrich_cost_if_all_match: "如果所有 {rows} 行都符合",
  enrich_cost_breakdown_email: "電子郵件",
  enrich_cost_breakdown_phone: "電話",
  enrich_cost_breakdown_company: "公司資訊",
  enrich_company_enrichment_label: "同時包含公司資訊（網域、名稱、通用電話、產業）",
  enrich_company_enrichment_needs_domain: "將 CSV 欄位對應到公司網域以啟用此功能。",
  enrich_cost_only_matched: "僅符合的行會扣費。未符合的行不消耗信用點。",
  enrich_cost_balance: "信用點餘額",
  enrich_cost_current_balance: "目前餘額",
  enrich_cost_after_max: "最壞情況支出後的餘額",
  enrich_cost_contact_types: "要增強的聯絡人類型",
  enrich_cost_start: "開始增強",
  enrich_cost_estimate_failed: "無法估算增強成本",
  enrich_cost_start_failed: "無法開始增強",

  enrich_summary_title: "摘要",
  enrich_summary_file_title: "來源檔案",
  enrich_summary_file_empty: "在第 1 步放入 CSV 開始",
  enrich_summary_kind: "類型",
  enrich_summary_rows: "行數",
  enrich_summary_columns: "欄數",
  enrich_summary_sample: "範例行",
  enrich_summary_mapping_title: "對應",
  enrich_summary_mapping_empty: "待定",
  enrich_summary_mapping_count: "已對應 {n} 個欄位 | 已對應 {n} 個欄位",
  enrich_summary_contact_types: "聯絡人類型",
  enrich_summary_match_method: "比對方式",
  enrich_summary_match_method_pending: "對應比對鍵以開始",
  enrich_summary_cost_title: "估算成本",
  enrich_summary_cost_sub: "僅符合的行扣費",
  enrich_summary_howto_title: "比對的運作方式",
  enrich_summary_howto_1: "我們透過電子郵件、領英網址或姓名 + 公司進行比對。",
  enrich_summary_howto_2: "每個符合的行都會按您選擇的聯絡人類型進行增強。",
  enrich_summary_howto_3: "未符合的行回傳空值，不消耗信用點。",

  enrich_run_running_title: "正在增強您的檔案…",
  enrich_run_running_desc: "可能需要幾分鐘。您可以離開此頁面 — 我們會在背景繼續處理。",
  enrich_run_submitting_title: "正在啟動您的增強任務…",
  enrich_run_submitting_desc: "正在向伺服器提交任務。通常幾秒內完成。",
  enrich_run_email_hint: "增強檔案準備就緒時，我們會透過電子郵件通知您。",
  enrich_run_failed_title: "增強失敗",
  enrich_run_failed_desc: "處理檔案時發生錯誤。",
  enrich_run_try_again: "重試",
  enrich_run_done_title: "增強完成",
  enrich_run_download_csv: "下載 CSV",
  enrich_run_view_in_app: "在應用程式中查看",
  enrich_run_new_job: "開始新任務",
  enrich_run_download_failed: "無法下載增強檔案",

  enrich_metric_rows: "檔案中的行數",
  enrich_metric_processed: "已處理的行",
  enrich_metric_matched: "已比對",
  enrich_metric_unmatched: "未比對",
  enrich_metric_credits_used: "已使用的信用點",
  enrich_run_rows_skipped: "跳過 {total} 行：{empty} 空行，{invalid} 個無效領英網址。",

  enrich_jobs_title: "增強歷史",
  enrich_jobs_empty: "尚無增強任務。切換到「新增增強」以上傳您的第一個 CSV。",
  enrich_jobs_filename: "檔案",
  enrich_jobs_kind: "類型",
  enrich_jobs_submitted: "提交時間",
  enrich_jobs_rows: "行數",
  enrich_jobs_matched: "已比對",
  enrich_jobs_credits: "信用點",
  enrich_jobs_status: "狀態",
  enrich_jobs_actions: "操作",
  enrich_status_queued: "已排隊",
  enrich_status_running: "執行中",
  enrich_status_completed: "已完成",
  enrich_status_failed: "失敗",
  enrich_history_search_placeholder: "依檔案名稱搜尋",
  enrich_history_filename_unknown: "未命名增強",
  "enrich_history-table-empty-title": "尚無增強任務",
  "enrich_history-table-empty-desc": "在「新增增強」中上傳 CSV 以開始。",
  enrich_run_progress_label: "正在增強",
  enrich_run_progress_complete: "完成！",

  enrich_results_title: "增強結果",
  enrich_results_showing: "顯示 {rows} 行",
  enrich_results_showing_filtered: "顯示 {rows} / {total} 行",
  enrich_results_search_placeholder: "搜尋行",
  enrich_results_empty: "此任務尚未產生結果檔案。",
  enrich_results_no_match: "沒有行符合您的搜尋。",
  enrich_results_load_failed: "無法載入結果",
  enrich_results_matched: "已比對 {count}",
  enrich_results_columns: "欄位",
};

export const enrich_ja = {
  enrich_tab_new: "新しい拡充",
  enrich_tab_history: "履歴",
  enrich_no_profile: "アクティブなプロファイルが選択されていません",

  enrich_wizard_title: "CSV を拡充",
  enrich_wizard_subtitle: "ファイルをアップロードしてください。各行を Pubrio のデータベースと照合します。マッチした行にのみ課金されます。",
  ComingSoon: "近日公開",

  enrich_step_upload: "アップロード",
  enrich_step_map: "列のマッピング",
  enrich_step_run: "実行",

  enrich_kind_title: "何を拡充しますか？",
  enrich_kind_desc: "ファイル内のレコードの種類を選択してください。",
  enrich_kind_people_title: "人物",
  enrich_kind_people_desc: "連絡先を照合して、検証済みのメール、電話、LinkedIn プロフィール、役職を取得します。",
  enrich_kind_people_eg: "例：名、姓、会社名を含む見込み客の CSV。",
  enrich_kind_company_title: "企業",
  enrich_kind_company_desc: "企業を照合して、ドメイン、業界、規模、本社所在地を取得します。",
  enrich_kind_company_eg: "例：企業名またはドメインの CSV。",

  enrich_upload_title: "ファイルをアップロード",
  enrich_upload_desc: "ファイルをドラッグ＆ドロップするか、参照してください。.csv、.xlsx、.xls、.txt に対応。",
  enrich_upload_hint: "ファイルあたり最大 {rows} 行",
  enrich_upload_done_meta: "{rows} 行 · {cols} 列を検出",
  enrich_upload_replace: "置き換え",
  enrich_notify_by_email: "拡充が完了したらメールで通知する",

  enrich_map_title: "列をマッピング",
  enrich_map_subtitle: "{count} 行を検出しました。各 CSV 列を拡充フィールドにマッピングしてください。",
  enrich_map_file_column: "あなたの CSV 列",
  enrich_map_target_field: "Pubrio フィールド",
  enrich_map_auto_detected: "自動検出",
  enrich_map_match_key_required: "拡充を有効にするには、LinkedIn URL をマッピングするか、氏名（または名 + 姓）+ 会社（名称またはドメイン）をマッピングしてください。",
  enrich_disabled_no_kind: "まず拡充タイプを選択してください。",
  enrich_disabled_no_file: "続行するにはファイルをアップロードしてください。",
  enrich_disabled_no_contact_types: "拡充する連絡先タイプを 1 つ以上選択してください。",
  enrich_map_strategy_linkedin: "各行を LinkedIn URL でマッチします。",
  enrich_map_strategy_email: "各行を仕事用メールでマッチします。",
  enrich_map_strategy_name_company: "各行を氏名と会社でマッチします。",
  enrich_map_strategy_mixed: "各行は最適な方法（LinkedIn URL、メール、または氏名 + 会社）でマッチします。",
  enrich_map_strategy_company: "ドメインで各社を検索します。",
  enrich_map_hint_need_company_key: "会社のドメインまたは会社名をマップしてください。",
  enrich_map_hint_need_company_domain: "会社ドメイン列(またはドメインを抽出できるメール列)をマップしてください。",
  enrich_match_status_matched: "マッチ",
  enrich_match_status_unmatched: "未マッチ",
  enrich_match_status_no_match_key: "マッチキーなし",
  enrich_match_status_no_linkedin_url: "LinkedIn URL なし",
  enrich_map_hint_start: "LinkedIn URL、または氏名 + 会社をマッピングしてください。",
  enrich_map_hint_need_company: "あと一歩 — 会社名または会社ドメインの列もマッピングしてください。",
  enrich_map_hint_need_last_name: "姓と会社（名称またはドメイン）も必要です。",
  enrich_map_hint_need_first_name: "名と会社（名称またはドメイン）も必要です。",
  enrich_map_hint_need_name: "氏名（または名 + 姓）も必要です。",

  enrich_cost_review_title: "確認して開始",
  enrich_cost_contact_types_title: "拡充する連絡先タイプ",
  enrich_cost_contact_types_desc: "マッチした連絡先ごとに返してほしい内容を選択してください。マッチごと、タイプごとに課金されます。",
  enrich_contact_email_desc: "検証済みの仕事用メールアドレス。",
  enrich_contact_phone_desc: "直通または仕事用の電話番号。",
  enrich_contact_mobile_desc: "利用可能な個人の携帯番号。",
  enrich_cost_summary_title: "拡充の概要",
  enrich_cost_filename: "ファイル",
  enrich_cost_rows_total: "ファイル内の行数",
  enrich_cost_rows_unique: "重複排除後のユニーク行",
  enrich_cost_max_credits: "すべての行がマッチした場合",
  enrich_cost_per_row: "マッチ行あたりの合計",
  enrich_cost_if_all_match: "すべての {rows} 行がマッチした場合",
  enrich_cost_breakdown_email: "メール",
  enrich_cost_breakdown_phone: "電話",
  enrich_cost_breakdown_company: "企業情報",
  enrich_company_enrichment_label: "企業情報も含める（ドメイン、名称、代表電話、業界）",
  enrich_company_enrichment_needs_domain: "これを有効にするには、CSV 列を企業ドメインにマッピングしてください。",
  enrich_cost_only_matched: "マッチした行にのみ課金されます。マッチしない行はクレジットを消費しません。",
  enrich_cost_balance: "クレジット残高",
  enrich_cost_current_balance: "現在の残高",
  enrich_cost_after_max: "最悪の場合の支出後の残高",
  enrich_cost_contact_types: "拡充する連絡先タイプ",
  enrich_cost_start: "拡充を開始",
  enrich_cost_estimate_failed: "拡充コストを見積もれませんでした",
  enrich_cost_start_failed: "拡充を開始できませんでした",

  enrich_summary_title: "概要",
  enrich_summary_file_title: "ソースファイル",
  enrich_summary_file_empty: "ステップ 1 で CSV をドロップして開始",
  enrich_summary_kind: "タイプ",
  enrich_summary_rows: "行",
  enrich_summary_columns: "列",
  enrich_summary_sample: "サンプル行",
  enrich_summary_mapping_title: "マッピング",
  enrich_summary_mapping_empty: "保留中",
  enrich_summary_mapping_count: "{n} フィールドをマッピング | {n} フィールドをマッピング",
  enrich_summary_contact_types: "連絡先タイプ",
  enrich_summary_match_method: "マッチング方法",
  enrich_summary_match_method_pending: "開始するにはマッチキーをマッピング",
  enrich_summary_cost_title: "見積もりコスト",
  enrich_summary_cost_sub: "マッチした行のみ課金",
  enrich_summary_howto_title: "マッチングの仕組み",
  enrich_summary_howto_1: "メール、LinkedIn URL、または氏名 + 会社でマッチします。",
  enrich_summary_howto_2: "マッチした行は、選択した連絡先タイプで拡充されます。",
  enrich_summary_howto_3: "マッチしない行は空の値を返し、クレジットを消費しません。",

  enrich_run_running_title: "ファイルを拡充中…",
  enrich_run_running_desc: "数分かかる場合があります。このページを離れても、バックグラウンドで処理を続けます。",
  enrich_run_submitting_title: "拡充ジョブを開始しています…",
  enrich_run_submitting_desc: "サーバーにジョブを送信中。通常は数秒で完了します。",
  enrich_run_email_hint: "拡充ファイルの準備ができたらメールでお知らせします。",
  enrich_run_failed_title: "拡充に失敗しました",
  enrich_run_failed_desc: "ファイルの処理中に問題が発生しました。",
  enrich_run_try_again: "再試行",
  enrich_run_done_title: "拡充完了",
  enrich_run_download_csv: "CSV をダウンロード",
  enrich_run_view_in_app: "アプリで表示",
  enrich_run_new_job: "新しいジョブを開始",
  enrich_run_download_failed: "拡充ファイルをダウンロードできませんでした",

  enrich_metric_rows: "ファイル内の行数",
  enrich_metric_processed: "処理済みの行",
  enrich_metric_matched: "マッチ",
  enrich_metric_unmatched: "アンマッチ",
  enrich_metric_credits_used: "使用クレジット",
  enrich_run_rows_skipped: "{total} 行をスキップ：{empty} 空、{invalid} 無効な LinkedIn URL。",

  enrich_jobs_title: "拡充履歴",
  enrich_jobs_empty: "拡充ジョブはまだありません。「新しい拡充」に切り替えて最初の CSV をアップロードしてください。",
  enrich_jobs_filename: "ファイル",
  enrich_jobs_kind: "タイプ",
  enrich_jobs_submitted: "送信日時",
  enrich_jobs_rows: "行",
  enrich_jobs_matched: "マッチ",
  enrich_jobs_credits: "クレジット",
  enrich_jobs_status: "ステータス",
  enrich_jobs_actions: "アクション",
  enrich_status_queued: "キュー中",
  enrich_status_running: "実行中",
  enrich_status_completed: "完了",
  enrich_status_failed: "失敗",
  enrich_history_search_placeholder: "ファイル名で検索",
  enrich_history_filename_unknown: "無題の拡充",
  "enrich_history-table-empty-title": "拡充ジョブはまだありません",
  "enrich_history-table-empty-desc": "「新しい拡充」で CSV をアップロードして開始してください。",
  enrich_run_progress_label: "拡充中",
  enrich_run_progress_complete: "完了！",

  enrich_results_title: "拡充結果",
  enrich_results_showing: "{rows} 行を表示",
  enrich_results_showing_filtered: "{total} 行中 {rows} 行を表示",
  enrich_results_search_placeholder: "行を検索",
  enrich_results_empty: "このジョブはまだ結果ファイルを生成していません。",
  enrich_results_no_match: "検索に一致する行がありません。",
  enrich_results_load_failed: "結果を読み込めませんでした",
  enrich_results_matched: "{count} マッチ",
  enrich_results_columns: "列",
};

export const enrich_ko = {
  enrich_tab_new: "새 보강",
  enrich_tab_history: "기록",
  enrich_no_profile: "활성 프로필이 선택되지 않았습니다",

  enrich_wizard_title: "CSV 보강",
  enrich_wizard_subtitle: "파일을 업로드하세요. 각 행을 Pubrio 데이터베이스와 매칭합니다. 매칭된 행에 대해서만 요금이 부과됩니다.",
  ComingSoon: "곧 출시",

  enrich_step_upload: "업로드",
  enrich_step_map: "열 매핑",
  enrich_step_run: "실행",

  enrich_kind_title: "무엇을 보강하시겠습니까?",
  enrich_kind_desc: "파일의 레코드 유형을 선택하세요.",
  enrich_kind_people_title: "사람",
  enrich_kind_people_desc: "연락처를 매칭하여 검증된 이메일, 전화번호, LinkedIn 프로필, 직책을 찾습니다.",
  enrich_kind_people_eg: "예: 이름, 성, 회사가 포함된 잠재 고객 CSV.",
  enrich_kind_company_title: "회사",
  enrich_kind_company_desc: "회사를 매칭하여 도메인, 산업, 규모, 본사 위치를 찾습니다.",
  enrich_kind_company_eg: "예: 회사 이름 또는 도메인의 CSV.",

  enrich_upload_title: "파일 업로드",
  enrich_upload_desc: "파일을 끌어다 놓거나 찾아보세요. .csv, .xlsx, .xls, .txt를 지원합니다.",
  enrich_upload_hint: "파일당 최대 {rows}행",
  enrich_upload_done_meta: "{rows}행 · {cols}개 열 감지됨",
  enrich_upload_replace: "교체",
  enrich_notify_by_email: "보강이 완료되면 이메일로 알려주세요",

  enrich_map_title: "열 매핑",
  enrich_map_subtitle: "{count}행이 감지되었습니다. 각 CSV 열을 보강 필드에 매핑하세요.",
  enrich_map_file_column: "내 CSV 열",
  enrich_map_target_field: "Pubrio 필드",
  enrich_map_auto_detected: "자동 감지됨",
  enrich_map_match_key_required: "보강을 활성화하려면 LinkedIn URL을 매핑하거나, 이름(또는 이름 + 성) + 회사(이름 또는 도메인)를 매핑하세요.",
  enrich_disabled_no_kind: "먼저 보강 유형을 선택하세요.",
  enrich_disabled_no_file: "계속하려면 파일을 업로드하세요.",
  enrich_disabled_no_contact_types: "보강할 연락처 유형을 하나 이상 선택하세요.",
  enrich_map_strategy_linkedin: "각 행을 LinkedIn URL로 매칭합니다.",
  enrich_map_strategy_email: "각 행을 업무 이메일로 매칭합니다.",
  enrich_map_strategy_name_company: "각 행을 이름과 회사로 매칭합니다.",
  enrich_map_strategy_mixed: "각 행은 가장 적합한 방식(LinkedIn URL, 이메일, 또는 이름 + 회사)으로 매칭됩니다.",
  enrich_map_strategy_company: "도메인으로 각 회사를 조회합니다.",
  enrich_map_hint_need_company_key: "회사 도메인 또는 회사명을 매핑하세요.",
  enrich_map_hint_need_company_domain: "회사 도메인 열(또는 도메인을 추출할 수 있는 이메일 열)을 매핑하세요.",
  enrich_match_status_matched: "매칭됨",
  enrich_match_status_unmatched: "매칭 안 됨",
  enrich_match_status_no_match_key: "매칭 키 없음",
  enrich_match_status_no_linkedin_url: "LinkedIn URL 없음",
  enrich_map_hint_start: "LinkedIn URL 또는 이름 + 회사를 매핑하세요.",
  enrich_map_hint_need_company: "거의 다 됐어요 — 회사 이름 또는 회사 도메인 열도 매핑하세요.",
  enrich_map_hint_need_last_name: "성과 회사(이름 또는 도메인)도 매핑해야 합니다.",
  enrich_map_hint_need_first_name: "이름과 회사(이름 또는 도메인)도 매핑해야 합니다.",
  enrich_map_hint_need_name: "이름(또는 이름 + 성)도 매핑해야 합니다.",

  enrich_cost_review_title: "검토 후 시작",
  enrich_cost_contact_types_title: "보강할 연락처 유형",
  enrich_cost_contact_types_desc: "매칭된 각 연락처에 대해 반환받고 싶은 항목을 선택하세요. 매칭당, 유형당 요금이 부과됩니다.",
  enrich_contact_email_desc: "검증된 업무용 이메일 주소.",
  enrich_contact_phone_desc: "직통 또는 업무용 전화번호.",
  enrich_contact_mobile_desc: "사용 가능한 개인 휴대폰 번호.",
  enrich_cost_summary_title: "보강 요약",
  enrich_cost_filename: "파일",
  enrich_cost_rows_total: "파일의 행 수",
  enrich_cost_rows_unique: "중복 제거 후 고유 행",
  enrich_cost_max_credits: "모든 행이 매칭되는 경우",
  enrich_cost_per_row: "매칭된 행당 합계",
  enrich_cost_if_all_match: "모든 {rows}행이 매칭되는 경우",
  enrich_cost_breakdown_email: "이메일",
  enrich_cost_breakdown_phone: "전화",
  enrich_cost_breakdown_company: "회사 정보",
  enrich_company_enrichment_label: "회사 정보도 포함 (도메인, 이름, 대표 전화, 산업)",
  enrich_company_enrichment_needs_domain: "이를 활성화하려면 CSV 열을 회사 도메인에 매핑하세요.",
  enrich_cost_only_matched: "매칭된 행에 대해서만 요금이 부과됩니다. 매칭되지 않은 행은 크레딧을 사용하지 않습니다.",
  enrich_cost_balance: "크레딧 잔액",
  enrich_cost_current_balance: "현재 잔액",
  enrich_cost_after_max: "최악의 경우 지출 후 잔액",
  enrich_cost_contact_types: "보강할 연락처 유형",
  enrich_cost_start: "보강 시작",
  enrich_cost_estimate_failed: "보강 비용을 추정할 수 없습니다",
  enrich_cost_start_failed: "보강을 시작할 수 없습니다",

  enrich_summary_title: "요약",
  enrich_summary_file_title: "원본 파일",
  enrich_summary_file_empty: "1단계에서 CSV를 드롭하여 시작",
  enrich_summary_kind: "유형",
  enrich_summary_rows: "행",
  enrich_summary_columns: "열",
  enrich_summary_sample: "샘플 행",
  enrich_summary_mapping_title: "매핑",
  enrich_summary_mapping_empty: "보류 중",
  enrich_summary_mapping_count: "{n}개 필드 매핑됨 | {n}개 필드 매핑됨",
  enrich_summary_contact_types: "연락처 유형",
  enrich_summary_match_method: "매칭 방식",
  enrich_summary_match_method_pending: "시작하려면 매칭 키를 매핑하세요",
  enrich_summary_cost_title: "예상 비용",
  enrich_summary_cost_sub: "매칭된 행에만 과금",
  enrich_summary_howto_title: "매칭 방식",
  enrich_summary_howto_1: "이메일, LinkedIn URL 또는 이름 + 회사로 매칭합니다.",
  enrich_summary_howto_2: "매칭된 각 행은 선택한 연락처 유형으로 보강됩니다.",
  enrich_summary_howto_3: "매칭되지 않은 행은 빈 값을 반환하며 크레딧을 사용하지 않습니다.",

  enrich_run_running_title: "파일을 보강하는 중…",
  enrich_run_running_desc: "몇 분 정도 걸릴 수 있습니다. 이 페이지를 떠나도 백그라운드에서 계속 작업합니다.",
  enrich_run_submitting_title: "보강 작업을 시작하는 중…",
  enrich_run_submitting_desc: "서버에 작업을 제출하는 중입니다. 보통 몇 초 안에 완료됩니다.",
  enrich_run_email_hint: "보강된 파일이 준비되면 이메일로 알려드립니다.",
  enrich_run_failed_title: "보강 실패",
  enrich_run_failed_desc: "파일을 처리하는 중 문제가 발생했습니다.",
  enrich_run_try_again: "다시 시도",
  enrich_run_done_title: "보강 완료",
  enrich_run_download_csv: "CSV 다운로드",
  enrich_run_view_in_app: "앱에서 보기",
  enrich_run_new_job: "새 작업 시작",
  enrich_run_download_failed: "보강된 파일을 다운로드할 수 없습니다",

  enrich_metric_rows: "파일의 행 수",
  enrich_metric_processed: "처리된 행",
  enrich_metric_matched: "매칭됨",
  enrich_metric_unmatched: "매칭되지 않음",
  enrich_metric_credits_used: "사용된 크레딧",
  enrich_run_rows_skipped: "{total}행 건너뜀: {empty}개 비어 있음, {invalid}개 잘못된 LinkedIn URL.",

  enrich_jobs_title: "보강 기록",
  enrich_jobs_empty: "아직 보강 작업이 없습니다. \"새 보강\"으로 전환하여 첫 CSV를 업로드하세요.",
  enrich_jobs_filename: "파일",
  enrich_jobs_kind: "유형",
  enrich_jobs_submitted: "제출 시간",
  enrich_jobs_rows: "행",
  enrich_jobs_matched: "매칭됨",
  enrich_jobs_credits: "크레딧",
  enrich_jobs_status: "상태",
  enrich_jobs_actions: "작업",
  enrich_status_queued: "대기 중",
  enrich_status_running: "실행 중",
  enrich_status_completed: "완료됨",
  enrich_status_failed: "실패",
  enrich_history_search_placeholder: "파일명으로 검색",
  enrich_history_filename_unknown: "제목 없는 보강",
  "enrich_history-table-empty-title": "아직 보강 작업이 없습니다",
  "enrich_history-table-empty-desc": "\"새 보강\"에서 CSV를 업로드하여 시작하세요.",
  enrich_run_progress_label: "보강 중",
  enrich_run_progress_complete: "완료!",

  enrich_results_title: "보강된 결과",
  enrich_results_showing: "{rows}행 표시 중",
  enrich_results_showing_filtered: "{total}행 중 {rows}행 표시 중",
  enrich_results_search_placeholder: "행 검색",
  enrich_results_empty: "이 작업은 아직 결과 파일을 생성하지 않았습니다.",
  enrich_results_no_match: "검색과 일치하는 행이 없습니다.",
  enrich_results_load_failed: "결과를 불러올 수 없습니다",
  enrich_results_matched: "{count} 매칭됨",
  enrich_results_columns: "열",
};

export const enrich_hi = {
  enrich_tab_new: "नया संवर्धन",
  enrich_tab_history: "इतिहास",
  enrich_no_profile: "कोई सक्रिय प्रोफ़ाइल चयनित नहीं है",

  enrich_wizard_title: "CSV समृद्ध करें",
  enrich_wizard_subtitle: "अपनी फ़ाइल अपलोड करें। हम प्रत्येक पंक्ति को Pubrio के डेटाबेस से मिलाते हैं। केवल मिलान वाली पंक्तियों के लिए शुल्क लगता है।",
  ComingSoon: "जल्द आ रहा है",

  enrich_step_upload: "अपलोड",
  enrich_step_map: "कॉलम मैप करें",
  enrich_step_run: "चलाएँ",

  enrich_kind_title: "आप क्या समृद्ध कर रहे हैं?",
  enrich_kind_desc: "अपनी फ़ाइल में रिकॉर्ड का प्रकार चुनें।",
  enrich_kind_people_title: "लोग",
  enrich_kind_people_desc: "सत्यापित ईमेल, फ़ोन, LinkedIn प्रोफ़ाइल और जॉब टाइटल खोजने के लिए संपर्क मिलाएँ।",
  enrich_kind_people_eg: "उदा. प्रथम नाम, अंतिम नाम और कंपनी वाले लीड्स की CSV।",
  enrich_kind_company_title: "कंपनियाँ",
  enrich_kind_company_desc: "डोमेन, उद्योग, आकार और मुख्यालय स्थान खोजने के लिए कंपनियाँ मिलाएँ।",
  enrich_kind_company_eg: "उदा. कंपनी नाम या डोमेन की CSV।",

  enrich_upload_title: "अपनी फ़ाइल अपलोड करें",
  enrich_upload_desc: "फ़ाइल खींचें और छोड़ें, या ब्राउज़ करें। हम .csv, .xlsx, .xls और .txt समर्थन करते हैं।",
  enrich_upload_hint: "प्रति फ़ाइल अधिकतम {rows} पंक्तियाँ",
  enrich_upload_done_meta: "{rows} पंक्तियाँ · {cols} कॉलम का पता चला",
  enrich_upload_replace: "बदलें",
  enrich_notify_by_email: "जब संवर्धन तैयार हो तो मुझे ईमेल करें",

  enrich_map_title: "अपने कॉलम मैप करें",
  enrich_map_subtitle: "{count} पंक्तियाँ मिलीं। प्रत्येक CSV कॉलम को एक संवर्धन फ़ील्ड से मिलाएँ।",
  enrich_map_file_column: "आपका CSV कॉलम",
  enrich_map_target_field: "Pubrio फ़ील्ड",
  enrich_map_auto_detected: "स्वतः पता चला",
  enrich_map_match_key_required: "संवर्धन सक्षम करने के लिए LinkedIn URL मैप करें, या नाम (या प्रथम + अंतिम) + कंपनी (नाम या डोमेन) मैप करें।",
  enrich_disabled_no_kind: "पहले संवर्धन प्रकार चुनें।",
  enrich_disabled_no_file: "जारी रखने के लिए फ़ाइल अपलोड करें।",
  enrich_disabled_no_contact_types: "संवर्धन के लिए कम से कम एक संपर्क प्रकार चुनें।",
  enrich_map_strategy_linkedin: "हम प्रत्येक पंक्ति को LinkedIn URL से मिलाएँगे।",
  enrich_map_strategy_email: "हम प्रत्येक पंक्ति को कार्य ईमेल से मिलाएँगे।",
  enrich_map_strategy_name_company: "हम प्रत्येक पंक्ति को नाम और कंपनी से मिलाएँगे।",
  enrich_map_strategy_mixed: "प्रत्येक पंक्ति सबसे उपयुक्त तरीके से मिलेगी: LinkedIn URL, ईमेल, या नाम + कंपनी।",
  enrich_map_strategy_company: "हम प्रत्येक कंपनी को डोमेन से खोजेंगे।",
  enrich_map_hint_need_company_key: "कंपनी का डोमेन या नाम मैप करें।",
  enrich_map_hint_need_company_domain: "कंपनी डोमेन कॉलम (या ईमेल कॉलम जिससे हम डोमेन निकाल सकें) मैप करें।",
  enrich_match_status_matched: "मैच हुआ",
  enrich_match_status_unmatched: "मैच नहीं हुआ",
  enrich_match_status_no_match_key: "मैच कुंजी नहीं",
  enrich_match_status_no_linkedin_url: "LinkedIn URL नहीं",
  enrich_map_hint_start: "LinkedIn URL, या नाम + कंपनी मैप करें।",
  enrich_map_hint_need_company: "लगभग हो गया — कंपनी नाम या कंपनी डोमेन कॉलम भी मैप करें।",
  enrich_map_hint_need_last_name: "अंतिम नाम और कंपनी (नाम या डोमेन) भी चाहिए।",
  enrich_map_hint_need_first_name: "प्रथम नाम और कंपनी (नाम या डोमेन) भी चाहिए।",
  enrich_map_hint_need_name: "नाम (या प्रथम + अंतिम) भी चाहिए।",

  enrich_cost_review_title: "समीक्षा करें और शुरू करें",
  enrich_cost_contact_types_title: "समृद्ध करने के लिए संपर्क प्रकार",
  enrich_cost_contact_types_desc: "प्रत्येक मिलान वाले संपर्क के लिए जो वापस चाहते हैं चुनें। प्रति मिलान, प्रति प्रकार शुल्क लगता है।",
  enrich_contact_email_desc: "सत्यापित कार्य ईमेल पता।",
  enrich_contact_phone_desc: "सीधा डायल या कार्य फ़ोन नंबर।",
  enrich_contact_mobile_desc: "जहाँ उपलब्ध हो, व्यक्तिगत मोबाइल नंबर।",
  enrich_cost_summary_title: "संवर्धन सारांश",
  enrich_cost_filename: "फ़ाइल",
  enrich_cost_rows_total: "फ़ाइल में पंक्तियाँ",
  enrich_cost_rows_unique: "डुप्लिकेट हटाने के बाद अद्वितीय पंक्तियाँ",
  enrich_cost_max_credits: "यदि सभी पंक्तियाँ मिलती हैं",
  enrich_cost_per_row: "प्रति मिलान वाली पंक्ति कुल",
  enrich_cost_if_all_match: "यदि सभी {rows} पंक्तियाँ मिलती हैं",
  enrich_cost_breakdown_email: "ईमेल",
  enrich_cost_breakdown_phone: "फ़ोन",
  enrich_cost_breakdown_company: "कंपनी जानकारी",
  enrich_company_enrichment_label: "कंपनी जानकारी भी शामिल करें (डोमेन, नाम, सामान्य फ़ोन, उद्योग)",
  enrich_company_enrichment_needs_domain: "इसे सक्षम करने के लिए CSV कॉलम को कंपनी डोमेन से मैप करें।",
  enrich_cost_only_matched: "केवल मिलान वाली पंक्तियों के लिए शुल्क लगता है। मिलान न होने वाली पंक्तियाँ क्रेडिट का उपयोग नहीं करतीं।",
  enrich_cost_balance: "क्रेडिट शेष",
  enrich_cost_current_balance: "वर्तमान शेष",
  enrich_cost_after_max: "सबसे ख़राब स्थिति में खर्च के बाद शेष",
  enrich_cost_contact_types: "समृद्ध करने के लिए संपर्क प्रकार",
  enrich_cost_start: "संवर्धन शुरू करें",
  enrich_cost_estimate_failed: "संवर्धन लागत का अनुमान नहीं लगाया जा सका",
  enrich_cost_start_failed: "संवर्धन शुरू नहीं किया जा सका",

  enrich_summary_title: "सारांश",
  enrich_summary_file_title: "स्रोत फ़ाइल",
  enrich_summary_file_empty: "शुरू करने के लिए चरण 1 में CSV डालें",
  enrich_summary_kind: "प्रकार",
  enrich_summary_rows: "पंक्तियाँ",
  enrich_summary_columns: "कॉलम",
  enrich_summary_sample: "नमूना पंक्ति",
  enrich_summary_mapping_title: "मैपिंग",
  enrich_summary_mapping_empty: "लंबित",
  enrich_summary_mapping_count: "{n} फ़ील्ड मैप किया | {n} फ़ील्ड मैप किए",
  enrich_summary_contact_types: "संपर्क प्रकार",
  enrich_summary_match_method: "मिलान विधि",
  enrich_summary_match_method_pending: "शुरू करने के लिए मिलान कुंजी मैप करें",
  enrich_summary_cost_title: "अनुमानित लागत",
  enrich_summary_cost_sub: "केवल मिलान वाली पंक्तियों पर शुल्क",
  enrich_summary_howto_title: "मिलान कैसे काम करता है",
  enrich_summary_howto_1: "हम ईमेल, LinkedIn URL, या नाम + कंपनी पर मिलान करते हैं।",
  enrich_summary_howto_2: "प्रत्येक मिलान वाली पंक्ति आपके चुने हुए संपर्क प्रकारों से समृद्ध होती है।",
  enrich_summary_howto_3: "मिलान न होने वाली पंक्तियाँ खाली मान लौटाती हैं और क्रेडिट का उपयोग नहीं करतीं।",

  enrich_run_running_title: "आपकी फ़ाइल समृद्ध की जा रही है…",
  enrich_run_running_desc: "इसमें कुछ मिनट लग सकते हैं। आप यह पृष्ठ छोड़ सकते हैं — हम पृष्ठभूमि में काम करते रहेंगे।",
  enrich_run_submitting_title: "आपका संवर्धन कार्य आरंभ हो रहा है…",
  enrich_run_submitting_desc: "सर्वर पर कार्य भेजा जा रहा है। आमतौर पर कुछ ही सेकंड में पूर्ण होता है।",
  enrich_run_email_hint: "जब समृद्ध फ़ाइल तैयार होगी, हम आपको ईमेल भेजेंगे।",
  enrich_run_failed_title: "संवर्धन विफल",
  enrich_run_failed_desc: "फ़ाइल संसाधित करते समय कुछ गलत हुआ।",
  enrich_run_try_again: "पुनः प्रयास करें",
  enrich_run_done_title: "संवर्धन पूर्ण",
  enrich_run_download_csv: "CSV डाउनलोड करें",
  enrich_run_view_in_app: "ऐप में देखें",
  enrich_run_new_job: "नया कार्य शुरू करें",
  enrich_run_download_failed: "समृद्ध फ़ाइल डाउनलोड नहीं की जा सकी",

  enrich_metric_rows: "फ़ाइल में पंक्तियाँ",
  enrich_metric_processed: "संसाधित पंक्तियाँ",
  enrich_metric_matched: "मिलान",
  enrich_metric_unmatched: "बिना मिलान",
  enrich_metric_credits_used: "उपयोग किए गए क्रेडिट",
  enrich_run_rows_skipped: "{total} पंक्तियाँ छोड़ी गईं: {empty} खाली, {invalid} अमान्य LinkedIn URL।",

  enrich_jobs_title: "संवर्धन इतिहास",
  enrich_jobs_empty: "अभी तक कोई संवर्धन कार्य नहीं। अपनी पहली CSV अपलोड करने के लिए नया संवर्धन पर जाएँ।",
  enrich_jobs_filename: "फ़ाइल",
  enrich_jobs_kind: "प्रकार",
  enrich_jobs_submitted: "जमा किया गया",
  enrich_jobs_rows: "पंक्तियाँ",
  enrich_jobs_matched: "मिलान",
  enrich_jobs_credits: "क्रेडिट",
  enrich_jobs_status: "स्थिति",
  enrich_jobs_actions: "क्रियाएँ",
  enrich_status_queued: "कतार में",
  enrich_status_running: "चल रहा है",
  enrich_status_completed: "पूर्ण",
  enrich_status_failed: "विफल",
  enrich_history_search_placeholder: "फ़ाइलनाम से खोजें",
  enrich_history_filename_unknown: "बिना शीर्षक संवर्धन",
  "enrich_history-table-empty-title": "अभी तक कोई संवर्धन कार्य नहीं",
  "enrich_history-table-empty-desc": "शुरू करने के लिए नया संवर्धन में CSV अपलोड करें।",
  enrich_run_progress_label: "समृद्ध हो रहा है",
  enrich_run_progress_complete: "हो गया!",

  enrich_results_title: "समृद्ध परिणाम",
  enrich_results_showing: "{rows} पंक्तियाँ दिखा रहे हैं",
  enrich_results_showing_filtered: "{total} में से {rows} पंक्तियाँ दिखा रहे हैं",
  enrich_results_search_placeholder: "पंक्तियाँ खोजें",
  enrich_results_empty: "इस कार्य ने अभी तक परिणाम फ़ाइल नहीं बनाई है।",
  enrich_results_no_match: "आपकी खोज से कोई पंक्ति मेल नहीं खाती।",
  enrich_results_load_failed: "परिणाम लोड नहीं किए जा सके",
  enrich_results_matched: "{count} मिलान",
  enrich_results_columns: "कॉलम",
};
